import BusinessOutcomesContext from './BusinessOutcomesContext';
import MilestonesContext from '../milestones/MilestonesContext';
import { useProjectOutcomes } from './hooks/useOutcomes';
import { useProjectDataContext } from 'domain/shared/newProject';
import { Loading } from 'framework/ui/mui-builder';

const OutcomesLayout = () => {
  const { data: projectData } = useProjectDataContext();
  const { isDataReloading, data } = useProjectOutcomes(projectData.id);

  if (!data || isDataReloading) return <Loading isInitialPosition />;

  return (
    <>
      <BusinessOutcomesContext data={data} />
      <MilestonesContext data={data} />
    </>
  );
};
export default OutcomesLayout;
